import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'era-fullscreen',
  templateUrl: './fullscreen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet],
})
export class FullscreenComponent {
  @HostBinding('class') hostClass = 'd-flex h-100 w-100';
}
